// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioseriesCollection_container__o8zoF {
  width: 100%;
}

.AudioseriesCollection_idDisplay__aGeBh{
  background: linear-gradient(to right, #2c3e50, #3498db);
  padding: 7rem 1rem;
  margin-bottom: 2rem;
}

.AudioseriesCollection_headTitle__5NsRu{
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
}

.AudioseriesCollection_swiperContainer__4RBev {
  position: relative;
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
}

.AudioseriesCollection_swiperWrapper__yCKQH {
  padding: 10px;
}

/* New Grid Layout */
.AudioseriesCollection_audioGrid__be80r {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.AudioseriesCollection_mediaCard__r2iyd {
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.AudioseriesCollection_imageWrapper__-N86Q {
  position: relative;
  flex: 1 1;
  overflow: hidden;
}

.AudioseriesCollection_mediaImage__aBTOE {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AudioseriesCollection_overlay__LP6uv {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s;
}

.AudioseriesCollection_mediaCard__r2iyd:hover .AudioseriesCollection_overlay__LP6uv {
  opacity: 1;
}

.AudioseriesCollection_mediaLabel__k9534 {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
}

.AudioseriesCollection_labelText__khBFO {
  color: white;
  font-size: 12px;
}

.AudioseriesCollection_playButton__fqzLP {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}

.AudioseriesCollection_mediaCard__r2iyd:hover .AudioseriesCollection_playButton__fqzLP {
  opacity: 1;
}

.AudioseriesCollection_mediaInfo__wgcYO {
  padding: 12px;
  background-color: white;
}

.AudioseriesCollection_mediaTitle__XnN9d {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AudioseriesCollection_mediaDetails__-kZL4 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.AudioseriesCollection_detailBadge__4qaEp {
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}

/* New Pagination Styles */
.AudioseriesCollection_pagination__Aeer1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  gap: 8px;
}

.AudioseriesCollection_paginationButton__h1lDL {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.AudioseriesCollection_paginationButton__h1lDL:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.AudioseriesCollection_paginationButton__h1lDL:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.AudioseriesCollection_activePage__7SJFf {
  background-color: #3498db;
  color: white;
  border-color: #3498db;
}

.AudioseriesCollection_ellipsis__NX0T1 {
  margin: 0 4px;
}

.AudioseriesCollection_prevButton__1OB7v, .AudioseriesCollection_nextButton__K0byr {
  padding: 0 12px;
}

.AudioseriesCollection_resultsInfo__uSInk {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 16px;
}

.AudioseriesCollection_loadingContainer__GXowV {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  font-size: 18px;
  color: #666;
}

.AudioseriesCollection_noResults__CMhSd {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .AudioseriesCollection_audioGrid__be80r {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 15px;
  }
  
  .AudioseriesCollection_headTitle__5NsRu {
    font-size: 2rem;
    padding: 5rem 1rem;
  }
  
  .AudioseriesCollection_mediaCard__r2iyd {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .AudioseriesCollection_audioGrid__be80r {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 10px;
  }
  
  .AudioseriesCollection_mediaInfo__wgcYO {
    padding: 8px;
  }
  
  .AudioseriesCollection_mediaTitle__XnN9d {
    font-size: 14px;
    margin-bottom: 4px;
  }
  
  .AudioseriesCollection_mediaDetails__-kZL4 {
    font-size: 10px;
  }
  
  .AudioseriesCollection_headTitle__5NsRu {
    font-size: 1.5rem;
  }
  
  .AudioseriesCollection_mediaCard__r2iyd {
    height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/collection/AudioseriesCollection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n\n.idDisplay{\n  background: linear-gradient(to right, #2c3e50, #3498db);\n  padding: 7rem 1rem;\n  margin-bottom: 2rem;\n}\n\n.headTitle{\n  color: white;\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-align: center;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n  text-transform: uppercase;\n}\n\n.swiperContainer {\n  position: relative;\n  max-width: 1200px;\n  margin: auto;\n  padding: 0 20px;\n}\n\n.swiperWrapper {\n  padding: 10px;\n}\n\n/* New Grid Layout */\n.audioGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.mediaCard {\n  height: 350px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.imageWrapper {\n  position: relative;\n  flex: 1;\n  overflow: hidden;\n}\n\n.mediaImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.2);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.mediaCard:hover .overlay {\n  opacity: 1;\n}\n\n.mediaLabel {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.labelText {\n  color: white;\n  font-size: 12px;\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.mediaCard:hover .playButton {\n  opacity: 1;\n}\n\n.mediaInfo {\n  padding: 12px;\n  background-color: white;\n}\n\n.mediaTitle {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mediaDetails {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.detailBadge {\n  background: #f0f0f0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #666;\n}\n\n/* New Pagination Styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 30px 0;\n  gap: 8px;\n}\n\n.paginationButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #f0f0f0;\n}\n\n.paginationButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.activePage {\n  background-color: #3498db;\n  color: white;\n  border-color: #3498db;\n}\n\n.ellipsis {\n  margin: 0 4px;\n}\n\n.prevButton, .nextButton {\n  padding: 0 12px;\n}\n\n.resultsInfo {\n  text-align: center;\n  font-size: 14px;\n  color: #666;\n  margin-top: 16px;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  font-size: 18px;\n  color: #666;\n}\n\n.noResults {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .audioGrid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 15px;\n  }\n  \n  .headTitle {\n    font-size: 2rem;\n    padding: 5rem 1rem;\n  }\n  \n  .mediaCard {\n    height: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .audioGrid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 10px;\n  }\n  \n  .mediaInfo {\n    padding: 8px;\n  }\n  \n  .mediaTitle {\n    font-size: 14px;\n    margin-bottom: 4px;\n  }\n  \n  .mediaDetails {\n    font-size: 10px;\n  }\n  \n  .headTitle {\n    font-size: 1.5rem;\n  }\n  \n  .mediaCard {\n    height: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioseriesCollection_container__o8zoF`,
	"idDisplay": `AudioseriesCollection_idDisplay__aGeBh`,
	"headTitle": `AudioseriesCollection_headTitle__5NsRu`,
	"swiperContainer": `AudioseriesCollection_swiperContainer__4RBev`,
	"swiperWrapper": `AudioseriesCollection_swiperWrapper__yCKQH`,
	"audioGrid": `AudioseriesCollection_audioGrid__be80r`,
	"mediaCard": `AudioseriesCollection_mediaCard__r2iyd`,
	"imageWrapper": `AudioseriesCollection_imageWrapper__-N86Q`,
	"mediaImage": `AudioseriesCollection_mediaImage__aBTOE`,
	"overlay": `AudioseriesCollection_overlay__LP6uv`,
	"mediaLabel": `AudioseriesCollection_mediaLabel__k9534`,
	"labelText": `AudioseriesCollection_labelText__khBFO`,
	"playButton": `AudioseriesCollection_playButton__fqzLP`,
	"mediaInfo": `AudioseriesCollection_mediaInfo__wgcYO`,
	"mediaTitle": `AudioseriesCollection_mediaTitle__XnN9d`,
	"mediaDetails": `AudioseriesCollection_mediaDetails__-kZL4`,
	"detailBadge": `AudioseriesCollection_detailBadge__4qaEp`,
	"pagination": `AudioseriesCollection_pagination__Aeer1`,
	"paginationButton": `AudioseriesCollection_paginationButton__h1lDL`,
	"activePage": `AudioseriesCollection_activePage__7SJFf`,
	"ellipsis": `AudioseriesCollection_ellipsis__NX0T1`,
	"prevButton": `AudioseriesCollection_prevButton__1OB7v`,
	"nextButton": `AudioseriesCollection_nextButton__K0byr`,
	"resultsInfo": `AudioseriesCollection_resultsInfo__uSInk`,
	"loadingContainer": `AudioseriesCollection_loadingContainer__GXowV`,
	"noResults": `AudioseriesCollection_noResults__CMhSd`
};
export default ___CSS_LOADER_EXPORT___;
